import { ZodIssue } from 'zod'
import { useTranslation } from 'react-i18next'
import { compact } from 'es-toolkit'
import toast from 'react-hot-toast'

export default function useTranslatedZodErrors({
  stringKeysPrefix = ''
}: {
  stringKeysPrefix?: string
}) {
  const { t } = useTranslation()
  const generateErrorKey = (errorPath: PropertyKey[], errorCode: string) =>
    compact([stringKeysPrefix, errorPath.map(String).join('.'), 'errors', errorCode]).join('.')

  const generateLabelKey = (errorPath: PropertyKey[]) =>
    compact([stringKeysPrefix, errorPath.map(String).join('.'), 'label']).join('.')

  const parse = (errors: ZodIssue[]) => {
    return errors.map(error => ({
      label: t(generateLabelKey(error.path)),
      message: t(generateErrorKey(error.path, error.code))
    }))
  }

  const showToast = (errors: ZodIssue[]) => {
    toast.error(
      parse(errors)
        .map(issue => `${issue.label}: ${issue.message}`)
        .join('\n'),
      {
        position: 'top-center'
      }
    )
  }

  return {
    parse,
    showToast
  }
}
